import { Box, Stack, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import BaseColorText from "../../BaseColorText";
import BaseImage from "../../BaseImage"

import { setStorage } from "../../../hooks/use-local-storage";
import SuccessImage from "../../../assets/images/home/signup-success.svg"

export default function SignUpSuccessModal({ close }) {
  const handleClickClose = () => {
    setStorage('showSignUpSuccessModal', 'hidden')
    close()
  }
  return (
    <Box sx={{
      maxWidth: '414px',
      borderRadius: '16px',
      boxShadow: '0px 2px 10px 0px #5B87EF33',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      background: 'white',
      padding: '40px 32px',
      position: 'relative'
    }}>
      <CloseIcon 
        sx={{
          position: 'absolute',
          right: '20px',
          top: '20px',
          color: 'primary.mediumGray',
          fontSize: '32px',
          cursor: 'pointer'
        }}
        onClick={handleClickClose}
      />
      <Stack
        spacing={'24px'}
        direction={'column'}
      >
        <Box>
          <BaseImage 
            src={SuccessImage}
            sx={{
              mt: '10px'
            }}
          />
        </Box>
        <Typography variant="h1">
          <BaseColorText isGradient gradientColor='#5A3BC7 7.57%, #5B87EF 88.27%'>Welcome to your Physician’s Portal!</BaseColorText>
        </Typography>
        <Typography variant="h4" color="primary.darkGray">
          Your account has been successfully created!
        </Typography>
      </Stack>
    </Box>
  )
}